import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../../app/_services/app.service';
import { CommonService } from '../../../../app/_services/common.service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { Helpers } from '../../../../app/helpers';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { OrdersService } from '../../services/orders/orders.service';

@Component({
  selector: 'app-inspection-checklist',
  templateUrl: './inspection-checklist.component.html',
  styleUrls: ['./inspection-checklist.component.scss']
})
export class InspectionChecklistComponent implements OnInit {

  data: any = {};
  CompanyId: any;
  TenantId: any;
  userId: any;
  isMobileView: boolean = false;
  isFormSubmit: boolean = false;
  FormId: any;
  VehicleId: any;
  SerialNo: any;
  VehicleNo: any;
  TransactionId: any;
  QuestionDataList: any;
  VehicleCheckListAnswers: any = [];
  GetAnswers: any;
  Questions: any = {}

  constructor(
    private orderservice: OrdersService,
    private _appService: appService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private router: Router,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private mobileDetectionService: MobileDetectionService,
    private commonService: CommonService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.FormId = this.route.snapshot.queryParamMap.get('FormId');
    this.userId = this.route.snapshot.queryParamMap.get('userId');
    this.VehicleId = this.route.snapshot.queryParamMap.get('VehicleId');
    this.VehicleNo = this.route.snapshot.queryParamMap.get('VehicleNo');
    this.TransactionId = this.route.snapshot.queryParamMap.get('TransactionId');
    this.SerialNo = this.route.snapshot.queryParamMap.get('SerialNo') || localStorage.getItem('SerialNo');
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    if (this.FormId !== 'undefined' && this.FormId !== 'null') {
      this.GetVehicleChecklist();
    }
  }

  GetVehicleChecklist(){
    Helpers.setLoading(true);
    this._appService.GetbyFormId("CheckList", "GetAllCheckList", this.FormId).subscribe((res) => {
      // this.QuestionDataList = res as any;
      Helpers.setLoading(false);
      this.QuestionDataList = res.map(q => ({
        id: q.Id,
        lable: q.Questions,
        formControlName: q.Id,
        dataField: q.Id,
        isValueBind: true,
        isRequired: true,
        placeholder: `Select an option for ${q.Questions}`,
        dropdownList: q.QuestionsOptionsList.map(opt => ({
          value: opt.Id,
          label: opt.OptionName.trim()
        }))
      }));
      //For edit
      if (this.SerialNo) {
        this._appService.GetbyFormId("VehicleInspection", "GetQuestionAnswers", this.SerialNo).subscribe(response => {
          this.GetAnswers = response as any;
          this.QuestionDataList.forEach(q => {
            const answer = this.GetAnswers.find(a => a.QuestionId === q.id);
            if (answer) {
              q.SelectedAnswer = answer.QuestionsOptionsId;
              this.data[q.dataField] = answer.QuestionsOptionsId; // Pre-fill the model too
            }
          });
        });
      }
    });
  }

  saveAnswers(){
    this.isFormSubmit = true;
    for (let i = 0; i < this.QuestionDataList.length; i++) {
      const question = this.QuestionDataList[i];
      const fieldValue = this.data[question.dataField];
      if (this.commonService.isStringEmptyOrNull(fieldValue)) {
        this.toastr.error(`${question.lable} is required`, 'Error');
        this.isFormSubmit = false;
        break;
      }
    }
    if(this.isFormSubmit){
      this.VehicleCheckListAnswers = [];
      this.VehicleCheckListAnswers = this.QuestionDataList.map(question => {
        return {
          UserId: this.userId,
          QuestionsOptionsId: this.data[question.dataField],  // Use bound model instead of question.SelectedAnswer
          QuestionId: question.dataField,
          BookingId: null,
          TransactionId: this.TransactionId,
          Type: 'Vehicle Inspection',
          Transactiondate: new Date(),
          TransactionNo: this.SerialNo
        };
      });
      console.log('VehicleCheckListAnswers', this.VehicleCheckListAnswers)
      this._appService.Post("CheckList", "SaveVehicleInspectionAnswers", this.VehicleCheckListAnswers).subscribe((res) => {
        this.toastr.success("Vehicle Inspection Check List Answers saved Successfully", "Success")
        this.SerialNo = res;
        localStorage.setItem('SerialNo', this.SerialNo)
      }, (err) => {
        console.log("Error", err);
      });
    }
  }

  getChangedValue(value, fieldDetails) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    this.data[fieldDetails.dataField] = newValue;
  }

  BackToList() {
    this.router.navigateByUrl(`/NewVehicleInspection`);
  }

}
